/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TerminiVersioneAdminDTO } from './termini-versione-admin-dto';
import { TerminiBozzaDTO } from './termini-bozza-dto';


export interface TerminiPubblicoAdminDTO { 
    pubblico?: TerminiPubblicoAdminDTOPubblicoEnum;
    attivo?: boolean;
    versione_corrente?: number;
    bozza?: TerminiBozzaDTO;
    versioni?: Array<TerminiVersioneAdminDTO>;
}
export enum TerminiPubblicoAdminDTOPubblicoEnum {
    ESERCENTE = 'ESERCENTE',
    CASSIERE = 'CASSIERE'
};



